import Vue from 'vue';
import Router from 'vue-router';

import Index from '../views/index.vue';
import CoreAgent from '../views/core-agent.vue';
import Introduce from '../views/authentication/introduce.vue';
import ResourceIntroduce from '../views/resource-introduce.vue';
import Rule from '../views/authentication/rule.vue';
import Auth from '../views/authentication/auth.vue';
import Query from '../views/authentication/query.vue';

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/resource/:type',
      name: 'resource',
      component: ResourceIntroduce
    },
    {
      path: '/core-agent',
      name: 'core-agent',
      component: CoreAgent
    },
    {
      path: '/authentication',
      name: 'authentication',
      component: Auth,
      children: [
        {
          path: 'introduce',
          name: 'introduce',
          component: Introduce
        },
        {
          path: 'rule',
          name: 'rule',
          component: Rule
        },
        {
          path: 'query',
          name: 'query',
          component: Query
        }
      ]
    }
  ]
});

export default router;